
/**
 * @import internal modules
 */
import * as Utils from '@root-utils/index';
/**
 * @import external modules
 */

import * as React from "react";

import { Link } from 'react-router-dom';
import { pure } from 'recompose';

// component
const Component: React.FunctionComponent<any> = (props: InterfaceBreadcrumb<string>): JSX.Element =>{
    
    const { classnames, level0, level1, links, title,realTime,onPlayPause } = props;

    const onSliderBarre = () => Utils.hideShowlayout();

    return(
        <div className={classnames} > 
           <div className="breadcrumb">
                <div className="breadcrumb-header">
                    <div className="breadcrumb-infos">
                        <div className="breadcrumb-action left">
                            <span className="title-breadcrumb animated fadeInLeft"><span><Link to={{pathname:links}}>{title}</Link></span></span>
                            <span className="empty-barre"/>
                            <span className="breadcrumb-text animated fadeInDown">{level0}</span>
                            <span className="breadcrumb-next animated fadeInDown">{level1}</span>
                        </div>
                        { realTime && <div className="breadcrumb-btn left">
                        <div className="btn-hoverCard ">
                                <span className="brc-tn btn-text" id="seeCLass" onClick={onSliderBarre}>Class 5</span>
                                <span className="brc-tn" id="play-and-pause" onClick={onPlayPause}>Pause</span>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}
// interface 
export interface InterfaceBreadcrumb<T>{
    classnames: T,
    level1?:T,
    level0?:T,
    links?:T,
    title?:T,
    realTime:boolean,
    onPlayPause?:any
}
/**
 * DefaultProps values
 */
Component.defaultProps= {

}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/breadcrumb/component.tsx